import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=465f1272&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&id=465f1272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f1272",
  null
  
)

export default component.exports